import React from "react";
import { StandardPageHeader } from "@/components/layout/StandardPageHeader";
import { ShoppingBag } from "lucide-react";

const ApparelHeader: React.FC = () => {
  return (
    <StandardPageHeader
      title="Apparel Shop"
      subtitle="Manage and order custom apparel for your hive"
      icon={ShoppingBag}
    />
  );
};

export default ApparelHeader;
